import {isEmpty} from '@shared/helpers/lang'

import {getFamilyPayPaymentInfo} from '@web/actions/familyPay'
import {FamilyUser, RefundCode, VirtualAccountBankCodes} from '@web/core/constants'
import makeSlice from '@web/slices/payNext/sliceMaker'

import {initOrderSheetByAPI} from '../../actions'

const slice = makeSlice({
    extraReducers: (builder) => {
        builder
            .addCase(initOrderSheetByAPI.fulfilled, (state, {payload}) => {
                const {purchaser, naverpayPoint, payMethod, familyPay} = payload
                state.expirationDepositDate = payMethod.expirationDepositDate
                state.virtualAccount.bankCodes = VirtualAccountBankCodes

                const refundAccounts = purchaser.refundAccounts ?? []
                state.refund.accounts = refundAccounts
                state.refund.selected.accountKey =
                    refundAccounts.find(({defaultRefundAccount}) => defaultRefundAccount)?.accountKey ?? null
                state.refund.method = (function () {
                    const reloadableRechargePointAmount =
                        naverpayPoint?.chargePoint.rechargeableChargePoint.reloadableRechargePointAmount ?? 0
                    /**
                     * 무통장입금 환불방법을 결정하는 정책
                     * 충전가능남은한도 >= 0 && 환불계좌가 있을 경우 -> 본인계좌환불
                     * 그 외 -> 환불정산액 적립
                     */
                    return reloadableRechargePointAmount >= 0 && !isEmpty(payMethod.recentUsedFirstBankEasyPays)
                        ? RefundCode.BANK_ACCOUNT
                        : RefundCode.CHARGE_AMOUNT
                })()
                if (payMethod.billingPayMethods.virtualAccount) {
                    state.virtualAccount.billing = {
                        pgCp: payMethod.billingPayMethods.virtualAccount.pgCp,
                        pgId: payMethod.billingPayMethods.virtualAccount.pgId,
                        minimumAmount: payMethod.billingPayMethods.virtualAccount.minimumAmount,
                        maximumAmount: payMethod.billingPayMethods.virtualAccount.maximumAmount,
                    }
                }

                if (familyPay) {
                    if (familyPay.apiResultType === 'SUCCESS') {
                        state.familyPay.status = 'STABLE'
                        state.familyPay.role = familyPay.familyUserType
                        state.familyPay.subscribed = !!familyPay.familyUserType

                        /** 맴버인 경우에만 패밀리결제수단 이용을 위한 정보 초기화 */
                        if (familyPay.familyUserType === FamilyUser.MEMBER) {
                            state.familyPay.memberPaymentInfo = {
                                memo: '',
                                payerPayMemberNo: familyPay.payerPayMemberNo,
                                isFamilyPayAllowed: familyPay.approvalPayment,
                                isPreApprovalPaymentAllowed: familyPay.preApprovalPayment,
                                limit: familyPay.preApprovalPaymentAvailableAmountPerMonth,
                                type: familyPay.familyPayPaymentType,
                                used: familyPay.preApprovalPaymentPaidAmountPerMonth,
                            }
                        }

                        familyPay.preApprovalPaymentAvailableAmountPerOrder &&
                            (state.familyPay.preApprovalPaymentLimitPerTransaction =
                                familyPay.preApprovalPaymentAvailableAmountPerOrder)
                    } else {
                        state.familyPay.status = 'INVALID'
                        state.familyPay.invalidReason = 'FETCH_FAIL'
                    }
                }
            })
            .addCase(getFamilyPayPaymentInfo.pending, (state) => {
                state.familyPay.status = 'PENDING'
            })
            .addCase(getFamilyPayPaymentInfo.fulfilled, (state, {payload}) => {
                if (payload.apiResultType === 'SUCCESS') {
                    state.familyPay.status = 'STABLE'
                    state.familyPay.invalidReason = undefined
                    state.familyPay.role = payload.familyUserType
                    state.familyPay.subscribed = !!payload.familyUserType

                    /** 맴버인 경우에만 패밀리결제수단 이용을 위한 정보 초기화 */
                    if (payload.familyUserType === FamilyUser.MEMBER) {
                        state.familyPay.memberPaymentInfo = {
                            memo: '',
                            payerPayMemberNo: payload.payerPayMemberNo,
                            isFamilyPayAllowed: payload.approvalPayment,
                            isPreApprovalPaymentAllowed: payload.preApprovalPayment,
                            limit: payload.preApprovalPaymentAvailableAmountPerMonth,
                            type: payload.familyPayPaymentType,
                            used: payload.preApprovalPaymentPaidAmountPerMonth,
                        }
                    }

                    payload.preApprovalPaymentAvailableAmountPerOrder &&
                        (state.familyPay.preApprovalPaymentLimitPerTransaction =
                            payload.preApprovalPaymentAvailableAmountPerOrder)
                } else {
                    state.familyPay.status = 'INVALID'
                    state.familyPay.invalidReason = 'FETCH_FAIL'
                }
            })
            .addCase(getFamilyPayPaymentInfo.rejected, (state) => {
                state.familyPay.status = 'INVALID'
                state.familyPay.invalidReason = 'FETCH_FAIL'
            })
    },
})

export default slice.reducer
